<div data-pp-message data-pp-placement="product" data-pp-style-layout="text" data-pp-style-logo-type="primary"
    data-pp-style-text-color="black" data-pp-style-logo-position="left" [attr.data-pp-amount]="amount">
</div>